import { Injectable } from '@angular/core';
import { HttpClient,   } from '@angular/common/http';
import { SingleResponseDto, LoginRequestDto, TokensDto, LoginResponseDto, AuthRefreshTokenDto,  } from '@bugz-mono/shared-dtos';
import { environment } from '@bugz-mono/shared-environments'
import { Observable, of, throwError } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root', 
})
export class AuthApiService {

  private apiUrl= `${environment.apiUrl}/auth`;
  
  constructor(private http: HttpClient) {
    
  }
 
  login(dto: LoginRequestDto) : Observable<SingleResponseDto<LoginResponseDto>>{
    try {
        return this.http.post<SingleResponseDto<LoginResponseDto>>(`${this.apiUrl}/login`,dto);  
      } catch (error) {
        console.log(error);
        return of( {
          success:false,
          message: 'API Error',
          error: error
        });
      }
  }
  
  refreshTokens(dto: AuthRefreshTokenDto) : Observable<TokensDto|null>{
    try {
        return this.http.post<TokensDto>(`${this.apiUrl}/refresh-token`,dto);  
      } catch (error) {
        console.log(error);
        return of(null);
      }
  }

  
  
}